// Theme: electric
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'electric',
  name: 'ELECTRIC',
  tagline: 'ELECTRIC',
  description: 'Descarga eletrica. Amarelo neon de alta tensao sobre verde profundo.',
  category: 'neon-cyber',
  tier: 'rare',
  basePrice: 1100,
  swatches: ['#0A0F08', '#CCFF00', '#1A2A18', '#F0FF99'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 14px 36px rgba(204, 255, 0, 0.13)',
      '--shadow-card-active': '0 14px 36px rgba(204, 255, 0, 0.14)'
    },
    shellClasses: 'font-mono theme-electric'
  },
  colorVars: {
    '--accent': '#CCFF00',
    '--accent-foreground': '#0A0F08',
    '--background': '#0A0F08',
    '--border': '#3A6A1A',
    '--card': '#1A2A18',
    '--card-border-active': 'rgba(204, 255, 0, 0.78)',
    '--card-completed': '#22331F',
    '--card-foreground': '#F0FF99',
    '--card-glow': 'rgba(204, 255, 0, 0.18)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0F08',
    '--foreground': '#F0FF99',
    '--hold-fill': '#CCFF00',
    '--input': '#1A2A18',
    '--modal-bg': '#0A0F08',
    '--modal-border': '#3A6A1A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(204, 255, 0, 0.13)',
    '--muted': '#1A2A18',
    '--muted-foreground': '#CCFF00',
    '--nav-active': '#CCFF00',
    '--nav-bg': '#0A0F08',
    '--popover': '#1A2A18',
    '--popover-foreground': '#F0FF99',
    '--primary': '#CCFF00',
    '--primary-foreground': '#0A0F08',
    '--ring': '#CCFF00',
    '--secondary': '#3A6A1A',
    '--secondary-foreground': '#F0FF99',
    '--streak': '#CCFF00',
    '--success': '#22c55e',
    '--success-foreground': '#0A0F08',
    '--xp': '#CCFF00',
    '--xp-bg': '#1A2A18'
  },
  resolvedVars: {
    '--accent': '#CCFF00',
    '--accent-foreground': '#0A0F08',
    '--accent-foreground-hsl': '103 30% 5%',
    '--accent-foreground-oklch': 'from #0A0F08 l c h',
    '--accent-hsl': '72 100% 50%',
    '--accent-oklch': 'from #CCFF00 l c h',
    '--background': '#0A0F08',
    '--background-hsl': '103 30% 5%',
    '--background-oklch': 'from #0A0F08 l c h',
    '--border': '#3A6A1A',
    '--border-hsl': '96 61% 26%',
    '--border-oklch': 'from #3A6A1A l c h',
    '--border-w': '1px',
    '--card': '#1A2A18',
    '--card-border-active': 'rgba(204, 255, 0, 0.78)',
    '--card-completed': '#22331F',
    '--card-completed-hsl': '111 24% 16%',
    '--card-completed-oklch': 'from #22331F l c h',
    '--card-foreground': '#F0FF99',
    '--card-foreground-hsl': '69 100% 80%',
    '--card-foreground-oklch': 'from #F0FF99 l c h',
    '--card-glow': 'rgba(204, 255, 0, 0.18)',
    '--card-hsl': '113 27% 13%',
    '--card-oklch': 'from #1A2A18 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0F08',
    '--destructive-foreground-hsl': '103 30% 5%',
    '--destructive-foreground-oklch': 'from #0A0F08 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F0FF99',
    '--foreground-hsl': '69 100% 80%',
    '--foreground-oklch': 'from #F0FF99 l c h',
    '--hold-fill': '#CCFF00',
    '--hold-fill-hsl': '72 100% 50%',
    '--hold-fill-oklch': 'from #CCFF00 l c h',
    '--input': '#1A2A18',
    '--input-hsl': '113 27% 13%',
    '--input-oklch': 'from #1A2A18 l c h',
    '--modal-bg': '#0A0F08',
    '--modal-bg-hsl': '103 30% 5%',
    '--modal-bg-oklch': 'from #0A0F08 l c h',
    '--modal-border': '#3A6A1A',
    '--modal-border-hsl': '96 61% 26%',
    '--modal-border-oklch': 'from #3A6A1A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(204, 255, 0, 0.13)',
    '--muted': '#1A2A18',
    '--muted-foreground': '#CCFF00',
    '--muted-foreground-hsl': '72 100% 50%',
    '--muted-foreground-oklch': 'from #CCFF00 l c h',
    '--muted-hsl': '113 27% 13%',
    '--muted-oklch': 'from #1A2A18 l c h',
    '--nav-active': '#CCFF00',
    '--nav-active-hsl': '72 100% 50%',
    '--nav-active-oklch': 'from #CCFF00 l c h',
    '--nav-bg': '#0A0F08',
    '--nav-bg-hsl': '103 30% 5%',
    '--nav-bg-oklch': 'from #0A0F08 l c h',
    '--popover': '#1A2A18',
    '--popover-foreground': '#F0FF99',
    '--popover-foreground-hsl': '69 100% 80%',
    '--popover-foreground-oklch': 'from #F0FF99 l c h',
    '--popover-hsl': '113 27% 13%',
    '--popover-oklch': 'from #1A2A18 l c h',
    '--primary': '#CCFF00',
    '--primary-foreground': '#0A0F08',
    '--primary-foreground-hsl': '103 30% 5%',
    '--primary-foreground-oklch': 'from #0A0F08 l c h',
    '--primary-hsl': '72 100% 50%',
    '--primary-oklch': 'from #CCFF00 l c h',
    '--radius': '8px',
    '--ring': '#CCFF00',
    '--ring-hsl': '72 100% 50%',
    '--ring-oklch': 'from #CCFF00 l c h',
    '--secondary': '#3A6A1A',
    '--secondary-foreground': '#F0FF99',
    '--secondary-foreground-hsl': '69 100% 80%',
    '--secondary-foreground-oklch': 'from #F0FF99 l c h',
    '--secondary-hsl': '96 61% 26%',
    '--secondary-oklch': 'from #3A6A1A l c h',
    '--shadow-card': '0 14px 36px rgba(204, 255, 0, 0.13)',
    '--shadow-card-active': '0 14px 36px rgba(204, 255, 0, 0.14)',
    '--streak': '#CCFF00',
    '--streak-hsl': '72 100% 50%',
    '--streak-oklch': 'from #CCFF00 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A0F08',
    '--success-foreground-hsl': '103 30% 5%',
    '--success-foreground-oklch': 'from #0A0F08 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(72 100% 50% / 0.15)',
    '--xp': '#CCFF00',
    '--xp-bg': '#1A2A18',
    '--xp-bg-hsl': '113 27% 13%',
    '--xp-bg-oklch': 'from #1A2A18 l c h',
    '--xp-hsl': '72 100% 50%',
    '--xp-oklch': 'from #CCFF00 l c h'
  }
}
